import React, { Fragment, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { commonTheme } from 'themes';

import Header from 'components/molecules/Header/Header';
import AppNavigation from 'components/organisms/AppNavigation/AppNavigation';
import Footer from 'components/organisms/Footer/Footer';
import Home from 'pages/Home/Home';

import { useAuth0 } from '@auth0/auth0-react';
import { RecoilRoot } from 'recoil';
import RTL from 'RTL';
import i18n from 'i18n';
import { updateHeaders } from 'dataLayer/api/axiosClient';
import { useMediaQuery, useTheme } from '@material-ui/core';

const { PUBLIC_URL } = process.env;

function App() {
  const {
    loginWithRedirect,
    logout,
    user,
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
  } = useAuth0();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const accountName = user && (user.nickname ? user.nickname : user.name);

  useEffect(() => {
    getAccessTokenSilently()
      .then((response) => {
        window.localStorage.setItem('access_token', response);
        updateHeaders();
      })
      .catch((e) => {
        return console.log('No logged users.', e);
      });

    if (!isAuthenticated) {
      window.localStorage.removeItem('access_token');
    }
  }, [isAuthenticated]);

  const displayLanguage = window.localStorage.getItem('lan_xh');
  useEffect(() => {
    i18n.changeLanguage(displayLanguage ? displayLanguage : i18n.language);
  }, []);

  return (
    <Fragment>
      {/* https://material-ui.com/customization/theming/#nesting-the-theme */}
      {!isLoading && (
        <RecoilRoot>
          <RTL>
            <ThemeProvider theme={commonTheme}>
              <Router basename={PUBLIC_URL}>
                <Header
                  onAccountClick={() => loginWithRedirect()}
                  onSignOutClick={() =>
                    logout({
                      returnTo: `${window.location.origin}${PUBLIC_URL}`,
                    })
                  }
                  accountLabel={
                    isAuthenticated ? accountName : isMobile ? '' : 'Sign in'
                  }
                />
                <AppNavigation />
                {/* TODO: check if logged in */}
                <Home />
              </Router>
              <Footer version="1.2" />
            </ThemeProvider>
          </RTL>
        </RecoilRoot>
      )}
    </Fragment>
  );
}

export default App;
